import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLinkItems } from '../features/legal/legalLinks';

const legalLayoutStyle = {
  maxWidth: '800px',
  margin: '2rem auto',
  padding: '0 1rem',
  lineHeight: '1.6',
};

const legalNavStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem 1.25rem',
  marginTop: '2.5rem',
  paddingTop: '1rem',
  borderTop: '1px solid rgba(128, 128, 128, 0.3)',
  fontSize: '0.9rem',
};

const LegalLayout = ({ children }) => {
  return (
    <div style={legalLayoutStyle}>
      <p><Link to="/">← На главную</Link></p>
      {children}
      <nav style={legalNavStyle} aria-label="Юридические документы">
        <LegalLinkItems />
      </nav>
    </div>
  );
};

export default LegalLayout;
